var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgElementsIconChart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.437 18.75c.311 0 .563-.252.563-.563v-.562c0-.31-.252-.563-.563-.563H4.687V5.812c0-.31-.251-.562-.562-.562h-.562c-.311 0-.563.252-.563.563v11.812c0 .621.504 1.125 1.125 1.125h16.312zm-2.7-3.375c.225 0 .45-.225.45-.45v-8.1c0-.225-.225-.45-.45-.45h-.787c-.225 0-.45.225-.45.45v8.1c0 .225.225.45.45.45h.787zm-6.75 0c.225 0 .45-.225.45-.45V7.95c0-.225-.225-.45-.45-.45H10.2c-.225 0-.45.225-.45.45v6.975c0 .225.225.45.45.45h.788zm3.376 0c.224 0 .45-.225.45-.45V10.2c0-.225-.226-.45-.45-.45h-.788c-.225 0-.45.225-.45.45v4.725c0 .225.225.45.45.45h.788zm-6.75 0c.224 0 .45-.225.45-.45V12.45c0-.225-.226-.45-.45-.45h-.788c-.225 0-.45.225-.45.45v2.475c0 .225.225.45.45.45h.788z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElementsIconChart);
export default __webpack_public_path__ + "static/media/elements-icon-chart.2f8d4d23b8835a11fd9860939475ca51.svg";
export { ForwardRef as ReactComponent };